/**
 * main.js — Módulo principal da landing page Dra. Lissanya
 *
 * Responsável por:
 *  - Inicializar ícones Lucide
 *  - Scroll suave nos botões CTA
 *  - Fallback de animação on-scroll via IntersectionObserver
 *  - Exibir o ano corrente no rodapé
 */

import './style.css';

import {
  createIcons,
  CheckCircle,
  Users,
  PenTool,
  Scale,
  Gift,
  Rocket,
  MapPin,
  ChevronDown,
  ArrowRight,
  Calendar,
} from 'lucide';

// ──────────────────────────────────────────────
// Inicialização geral ao carregar o DOM
// ──────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  inicializarIcones();
  configurarScrollSuave();
  configurarAnimacaoScroll();
  exibirAnoAtual();
});

// ──────────────────────────────────────────────
// 1. Ícones — renderiza todos os ícones Lucide
//    presentes no HTML (atributo data-lucide)
// ──────────────────────────────────────────────
function inicializarIcones() {
  createIcons({
    icons: {
      CheckCircle,
      Users,
      PenTool,
      Scale,
      Gift,
      Rocket,
      MapPin,
      ChevronDown,
      ArrowRight,
      Calendar,
    },
  });
}

// ──────────────────────────────────────────────
// 2. Scroll suave — todos os botões CTA que
//    apontam para #inscricao rolam suavemente
// ──────────────────────────────────────────────
function configurarScrollSuave() {
  const botoesCta = document.querySelectorAll('.btn-cta[href="#inscricao"]');

  botoesCta.forEach((botao) => {
    botao.addEventListener('click', (evento) => {
      evento.preventDefault();

      const secaoInscricao = document.querySelector('#inscricao');

      if (secaoInscricao) {
        secaoInscricao.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

// ──────────────────────────────────────────────
// 3. Animação ao scroll — fallback com
//    IntersectionObserver para navegadores que
//    não suportam scroll-driven animations
//    (animation-timeline: view())
// ──────────────────────────────────────────────
function configurarAnimacaoScroll() {
  // Só utiliza o observer se scroll-driven animations NÃO forem suportadas
  if (!CSS.supports('animation-timeline: view()')) {
    // Sinaliza ao CSS que o JS vai controlar a animação
    document.body.classList.add('js-animate-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document
      .querySelectorAll('.animate-on-scroll')
      .forEach((el) => observer.observe(el));
  }
}

// ──────────────────────────────────────────────
// 4. Ano atual — insere o ano corrente no
//    elemento #current-year do rodapé
// ──────────────────────────────────────────────
function exibirAnoAtual() {
  const spanAno = document.getElementById('current-year');

  if (spanAno) {
    spanAno.textContent = new Date().getFullYear();
  }
}
